import React from 'react';
import { AccountTabs } from 'widgets/AccountList';
import { useScrollRestoration } from 'shared/lib/react-router';

const AccountsPage: React.FC = () => {
  useScrollRestoration();

  return <AccountTabs />;
};

export default AccountsPage;
